import React from "react";

export function LoadingUiStyles() {
  return (
    <style>{`
      .tm-loadingbar-wrap{
        height: 3px; border-radius: 999px; background: #eef2ff;
        overflow: hidden; margin-top: 10px;
      }
      .tm-loadingbar{
        height: 100%;
        width: 40%;
        background: #111827;
        transform: translateX(-120%);
        animation: tmbar 1.1s infinite;
      }
      @keyframes tmbar{
        0%{ transform: translateX(-120%); opacity: .35; }
        50%{ opacity: .9; }
        100%{ transform: translateX(260%); opacity: .35; }
      }
      .tm-spinner{
        width: 14px; height: 14px; border-radius: 999px;
        border: 2px solid #e5e7eb; border-top-color: #111827;
        animation: tmspin .8s linear infinite;
        display: inline-block;
      }
      @keyframes tmspin{
        from{ transform: rotate(0deg); }
        to{ transform: rotate(360deg); }
      }
    `}</style>
  );
}

export function LoadingBar({ loading }) {
  if (!loading) return null;
  return (
    <div className="tm-loadingbar-wrap" title="Loading">
      <div className="tm-loadingbar" />
    </div>
  );
}

export function LoadingInline({ loading, text = "Loading..." }) {
  if (!loading) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10 }}>
      <span className="tm-spinner" title="Loading" />
      <span style={{ color: "#64748b", fontSize: 14 }}>{text}</span>
    </div>
  );
}
